import type { AuthModeDto, GrantDto, LogoutDto, Me, SessionDto } from '@pb/shared';
import { asList, del, get, post } from './client';

export const login = (email: string, password: string) =>
  post<unknown>('/login', { email, password }, { skipAuthRedirect: true });
export const logout = () => post<LogoutDto>('/logout', {}, { skipAuthRedirect: true });
export const getAuthMode = () => get<AuthModeDto>('/auth/mode', { skipAuthRedirect: true });
export const getMe = () => get<Me>('/me', { skipAuthRedirect: true });

export const listSessions = async () => asList(await get<SessionDto[] | { items: SessionDto[] }>('/account/sessions'));
export const endSession = (id: number) => del<unknown>(`/account/sessions/${id}`);
export const listGrants = async () => asList(await get<GrantDto[] | { items: GrantDto[] }>('/account/grants'));
export const revokeGrant = (id: number) => del<unknown>(`/account/grants/${id}`);
